import type { GamificationEvent } from '../../types/auth';

/**
 * CORE-1751 (решение продукта, Мария, 19.10) — «сначала рефлексия,
 * поздравление — после того как человек её закроет».
 *
 * Свет души начисляется за ту же засчитанную практику, после которой
 * открывается окно рефлексии, и поздравление приходило вместе с ним: виджет
 * Агапеллы ложился поверх окна. Пока окно рефлексии на экране, поздравление
 * придержано — не показано и не отмечено прочитанным, — и появляется, как
 * только окно закрыли. Нет окна — нет и задержки.
 *
 * Придержано в источнике (`GamificationCelebrationProvider`), а не в каждом
 * показе: поздравление рисуют двое (виджет и окно подробностей), и забыть
 * одного значило бы показать его поверх рефлексии ровно там, где забыли.
 *
 * Отдельным модулем без AuthContext: тот тянет Sentry, и тест правила иначе
 * не собрался бы.
 */
export function celebrationToShow(
  queued: GamificationEvent | null, reflectionVisible: boolean,
): GamificationEvent | null {
  return reflectionVisible ? null : queued;
}
